<script setup lang="ts">
defineProps<{ visible: boolean }>()
</script>

<template>
  <Transition name="drop">
    <div v-if="visible" class="offline" role="status">
      <span class="offline__dot" aria-hidden="true" />
      <p class="offline__text">
        <strong>Conversor offline.</strong>
        Ele pode estar reiniciando — as conversões vão falhar até ele voltar.
      </p>
    </div>
  </Transition>
</template>

<style scoped>
.offline {
  position: sticky;
  top: 0;
  z-index: 40;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem var(--gutter);
  border-bottom: 1px solid var(--danger-line);
  background: color-mix(in srgb, var(--danger) 12%, var(--bg));
  backdrop-filter: blur(10px);
}

.offline__dot {
  flex: none;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--danger);
  box-shadow: 0 0 0 4px rgb(255 115 88 / 16%);
  animation: pulse-dot 1.8s ease-in-out infinite;
}

.offline__text {
  font-size: var(--step--1);
  color: var(--text);
}

.offline__text strong {
  font-weight: 600;
}

.drop-enter-active,
.drop-leave-active {
  transition:
    opacity var(--dur) var(--ease),
    transform var(--dur) var(--ease);
}

.drop-enter-from,
.drop-leave-to {
  opacity: 0;
  transform: translateY(-100%);
}
</style>
